"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var escape_attribute_1 = require("./escape-attribute");
/**
 * Represents an XML node.
 */
var XmlNode = /** @class */ (function () {
    function XmlNode(name, children) {
        if (children === void 0) { children = []; }
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    XmlNode.prototype.addAttribute = function (name, value) {
        this.attributes[name] = value;
        return this;
    };
    XmlNode.prototype.addChildNode = function (child) {
        this.children.push(child);
        return this;
    };
    XmlNode.prototype.removeAttribute = function (name) {
        delete this.attributes[name];
        return this;
    };
    XmlNode.prototype.toString = function () {
        var hasChildren = Boolean(this.children.length);
        var xmlText = "<" + this.name;
        // add attributes
        var attributes = this.attributes;
        for (var _i = 0, _a = Object.keys(attributes); _i < _a.length; _i++) {
            var attributeName = _a[_i];
            var attribute = attributes[attributeName];
            if (typeof attribute !== "undefined" && attribute !== null) {
                xmlText += " " + attributeName + "=\"" + escape_attribute_1.escapeAttribute("" + attribute) + "\"";
            }
        }
        return (xmlText += !hasChildren
            ? "/>"
            : ">" + this.children.map(function (c) { return c.toString(); }).join("") + "</" + this.name + ">");
    };
    return XmlNode;
}());
exports.XmlNode = XmlNode;
//# sourceMappingURL=XmlNode.js.map